import { IDocumentStackItemDto, IFolderOverviewItemDto } from './documentConfig'
import { AxiosResponseAction } from '../reducers'

export enum FileDocumentAction {
    GetOverview = 'GET_FILE_DOCUMENT_OVERVIEW',
    GetOverviewChildren = 'GET_FILE_DOCUMENT_OVERVIEW_CHILDREN',
    ResetOverview = 'RESET_FILE_DOCUMENT_OVERVIEW',
}

export const FileDocumentChildrenMap: Map<FileDocumentAction, FileDocumentAction> = new Map([
    [FileDocumentAction.GetOverview, FileDocumentAction.GetOverviewChildren],
])

export const FileDocumentParentMap: Map<FileDocumentAction, FileDocumentAction> = new Map([
    [FileDocumentAction.GetOverviewChildren, FileDocumentAction.GetOverview],
])

export interface IFileDocumentResponse extends AxiosResponseAction<IFolderOverviewItemDto[]> {
    stack: IDocumentStackItemDto[]
}
